define( function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/var/class2type.js
// module id = 198
// module chunks = 1